import { getAPI } from './ApiFunctions';
const { EPE_ACCESS_TOKEN } = require('../constants/index');
import { getMicrofrontendStargate } from './microFrontendStargateToken';

/**
 * function to retrieve an auth token from ui-utils
 * @param {String} key name of the token to retrieve (e.g. Stargate_token)
 * @param {String} overrideUrl optional different value to use for the access tokens url,
 * used for case where we may need a nonprod token when in beta (e.g. carepath beta/uat endpoint is considered nonprod)
 */
export const getAccessToken = async (key, overrideUrl = null, accessToken = null) => {
    const localStorageKey = overrideUrl
        ? `${EPE_ACCESS_TOKEN}-${key}-override`
        : `${EPE_ACCESS_TOKEN}-${key}`;
    let token = localStorage.getItem(localStorageKey);

    if (!token || JSON.parse(token).expiry < new Date().getTime()) {
        try {
            localStorage.removeItem(localStorageKey);
        } catch (err) {}
        const microFrontendToken = await getMicrofrontendStargate();
        const response = await getAPI(
            overrideUrl || process.env.ACCESS_TOKENS_URL,
            null,
            accessToken || microFrontendToken
        );

        response?.data?.forEach((result) => {
            if (result?.Name === key) {
                token = { value: result.Token };

                localStorage.setItem(
                    localStorageKey,
                    JSON.stringify({
                        value: result.Token,
                        expiry: new Date().getTime() + result.Expiration_in_seconds * 1000,
                    })
                );
            }
        });
    } else {
        token = JSON.parse(token);
    }

    return token.value;
};
